export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8057.38985e1a.jpg";